export const cookieKeys = {
    AWS_MARKETPLACE_TOKEN: `AWS-Marketplace-Token`,
    AZURE_MARKETPLACE_TOKEN: `AZURE-Marketplace-Token`,
    CLOUD_MARKETPLACE_TOKEN: `CLOUD-Marketplace-Token`,
};
//# sourceMappingURL=cookie-keys.enum.js.map